export class Credentials {
    constructor() {
        this.username = "";
        this.password = "";
    }
    validate(value) {
        if (value) {
            return true;
        }
        else {
            return false;
        }
    }
}
